import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const accountTypes = {
    account: "account",
    // retail: "business"
}

export const targetTypes = {
    account: "account",
    // retail: "business"
}

export function useAccounts({
    accountType: _accountType, 
    targetType: _targetType
}) {

    const [accountType, setAccountType] = useState(_accountType);
    const [targetType, setTargetType] = useState(_targetType)

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    // const endpoint = "account";
    const endpoint2 = "account";

    // const list = async (props) => {

    //     setIsLoading(true);

    //     try{

    //         let { businessType: overrideBusinessType } = props

    //         let endpointUrl = `${endpoint}/${businessType}`

    //         if(overrideBusinessType){
    //             setBusinessType(overrideBusinessType)
    //             endpointUrl = `${endpoint}/${overrideBusinessType}`
    //         }

    //         const url = getListsUrl(endpointUrl, props);

    //         const response = await makeCall({
    //             url,
    //             method: "GET",
    //             payload: {}
    //         });

    //         setIsLoading(false);

    //         return response;

    //     }catch(error){

    //         setIsLoading(false);
    //         throw error;

    //     }

    // }

    // const create = async ({ data }) => {

    //     setIsLoading(true)

    //     try{

    //         const url = endpoint2;

    //         let postData = {
    //             scope: {
    //                 target: targetType,
    //                 action: "",
    //             },
    //             payload: data
    //         }

    //         const response = await makeCall({
    //             url,
    //             method: "POST",
    //             payload: postData
    //         });

    //         setIsLoading(false);

    //         return response;

    //     }catch(error){

    //         setIsLoading(false);
    //         throw error;

    //     }

    // }

    const update = async ({ id, data, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            let url = `${endpoint2}/${id}`

            const postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    // const remove = async ({ ids, targetType: overrideTargetType }) => {

    //     setIsLoading(true);

    //     // if(ids.length <= 0){
    //     //     throw getError(false, `Please select at least (1) items`)
    //     // }

    //     try{

    //         const url = `${endpoint}/delete`

    //         let postData = {
    //             scope: {
    //                 target: targetType
    //             },
    //             payload: {
    //                 ids
    //             }
    //         }

    //         if(overrideTargetType) postData.scope.target = overrideTargetType

    //         const response = await makeCall({
    //             url,
    //             method: "POST",
    //             payload: postData
    //         });

    //         setIsLoading(false);

    //         return response;

    //     }catch(error){

    //         setIsLoading(false);
    //         throw error;

    //     }

    // } 

    const get = async ({ id }) => {

        setIsLoading(true);

        try {

            // let url = `${endpoint2}/${businessType}/${id}`
            let url = `${endpoint2}/${id}`

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        accountTypes,
        targetTypes,
        // list,
        get,
        // create,
        update,
        // remove 
    }
}